function Footer() {
  return (
    <div
      style={{
        height: "4rem",
        width: "100%",
        marginTop: "4rem",
        backgroundColor: "rgba(33,37,41,255)",
      }}
    ></div>
  );
}
export default Footer;
